module.exports = __webpack_public_path__ + "media/images/logo/logo_daiwaliving-866cc3f8a76b007fd63b8b41e39872b1.png";